import { cookies } from 'lib/enums';
import { LIVE_AGENT_EXCLUSION_LIST } from 'config/third_party';
import $ from 'jquery';
import Backbone from 'backbone';
import PurchaseView from 'views/store/pages/products/purchase';
import ConfigView from 'views/store/pages/products/config';
import HeadingView from 'views/store/pages/products/heading';
import UniqueIdView from 'views/store/pages/products/uniqueid';
import MediaGalleryView from 'views/store/pages/products/mediagallery';
import VideosView from 'views/store/pages/products/videos';
import ReviewsView from 'views/store/pages/products/reviews';
import RestrictionsView from 'views/store/pages/products/restrictions';
import PricedOptionView from 'views/store/pages/products/pricedoption';
import ProductModel from 'models/store/client/product/product';
import PricedOptionModel from 'models/store/client/product/pricedoption';
import SocialBarView from 'views/store/common/social/social_bar';
import VendorStockView from 'views/store/pages/products/vendor_stock.page';
import QuestionsView from 'views/store/pages/products/questions';
import LiveAgentInvitationView from 'views/store/common/live_agent_invitation';
import CartItemModel from 'models/store/client/cart/item';
import RebatesView from 'views/store/pages/products/rebates';
import dustjs from 'dustjs';
import _viewMoreButtonDust from 'store/mobile/pages/products/_view_more_button.dust';
import externalScriptLoader from 'externalScriptLoader';
import jsCookie from 'js-cookie';
import { clientUtils } from 'app/client_utils';
import 'vendor/matchmedia.addListener';
import 'jquery.scrollto';
import 'slick-carousel';
import gtmHelper from 'lib/helpers/gtm_helper';

window.BCOM.views = window.BCOM.views || {};
window.BCOM.models = window.BCOM.models || {};
window.BCOM.collections = window.BCOM.collections || {};

export default Backbone.View.extend({
	el: '#product',
	model: new ProductModel(window.dataLayer),
	events: {
		'click .js-rating-link': 'trackReviewLink',
		'click #product-tabs a': 'openTab',
		'shown.bs.tab a[href="#videos"]': '_initVideos',
		'shown.bs.collapse #videos': '_initVideos',
		'shown.bs.modal .js-video-modal': '_initVideos',
		'shown.bs.tab a[href="#accessoriesTab"]': '_initAccessoriesTab',
		'shown.bs.collapse #matching-products': '_initMatchingProducts',
		'shown.bs.tab a[href="#parts"]': '_initParts',
		'shown.bs.collapse #parts': '_initParts',
		'hidden.bs.modal .js-modal-product-options': '_notifyClosedModal',
		'click dl.divide-items a': 'trackHoverClick',
		'click .js-print': 'printWindow',
		'click .js-view-more': '_toggleFullTab',
		'click .js-full-title-toggle': '_toggleFullSubHeading',
		'click .js-finishes-menu .js-toggle-menu': '_finishMenuClosed',
		'click .js-add-accessory-to-cart': '_addAccessoryToCart',
		'click .js-product-anchor-track-link': '_trackAnchorLink',
		'click .js-credit-card-landing': '_creditCardLanding',
		'click .js-prop-65-popover': '_toggleProp65Popover',
		'click .js-prop-65-popover-icon': '_toggleProp65Popover',
		'click .js-tech-spec': '_techSpecPopoverPDP'
	},
	initialize: function() {
		externalScriptLoader('wistia', () => {
			const options = {
				parentView: this
			};
			$(window).on('scroll', this.onScroll);

			this.childViews.title = new HeadingView({
				model: this.model
			});
			this.childViews.uniqueid = new UniqueIdView({
				model: this.model
			});

			this.childViews.purchase = new PurchaseView(options);
			this.childViews.config = new ConfigView(options);
			this.childViews.mediaGallery = new MediaGalleryView({
				model: this.model
			});
			this.childViews.social = new SocialBarView();
			this.childViews.vendorStock = new VendorStockView();
			if (this.model.offersInstallation()) {
				this.childViews.installation = new PricedOptionView({
					model: new PricedOptionModel(this.model.getInstallationData())
				});
			}
			if (this.model.attributes.product.excessiveLead) {
				$('#excessiveLeadModal').modal('show');
			}
			import('views/store/pages/products/related_categories').then((RelatedCategoriesView) => {
				this.childViews.relatedCategories = new RelatedCategoriesView();
			});

			if (!window.dataLayer.siteId || !LIVE_AGENT_EXCLUSION_LIST.SITE_ID_LIST.includes(window.dataLayer.siteId)) {
				this.childViews.liveAgentInvitation = new LiveAgentInvitationView({
					sourcePage: 'product'
				});
			} else {
				$(document).ready(() => {
					$('.js-contact-links').remove();
				});
			}

			if (window.dataLayer.enableEcoRebates) {
				this.childViews.rebates = new RebatesView();
			}

			this.listenTo(Backbone, 'product:configurePricedOptions', this.configureProduct, this);

			this.listenTo(Backbone, 'tabContent:scrollTo', this.scrollToTabContent);

			window.matchMedia('(orientation:landscape)').addListener((event) => {
				this.handleOrientationChange(event.matches);
			});

			$(window).on('orientationchange', (event) => {
				this.handleOrientationChange(event.originalEvent['orientation'] === 'landscape');
			});

			$('body').popover({
				placement: 'top',
				trigger: 'focus',
				selector: '[data-toggle="popover"]'
			});

			if (this.$('#videos').is(':visible')) {
				this._initVideos();
			}
			if (this.$('#parts').is(':visible')) {
				this._initParts();
			}

			if (window.BCOM.device.isMobile) {
				this._addViewMoreButton('overview');
				$(window).on('scroll', () => {
					if ($(this).scrollTop() > 400) {
						this._loadTabs();
					}
				});
				if ($(window).scrollTop() > 400) {
					this._loadTabs();
				}
			}

			this.listenTo(Backbone, 'quantity:changed', this.updateRecommendedOptionQuantities, this);
			if (!this.model.get('hasNonServiceOptions') && !window.BCOM.device.isDesktop) {
				// We may have to show the 'configure' state of the page
				this.listenTo(Backbone, 'availability:stateChanged', this._onAvailabilityChanged, this);
			}

			this._initReviews(() => {
				this._initQuestions();
			});

			if (window.location.hash === '#reviews') {
				if (!window.BCOM.device.isMobile) {
					this._initReviews();
				}
				this.scrollToTabContent('reviewsRow');
			}

			this.saveLastProductUrl(window.dataLayer.selectedFinish.url);
			this._initRestrictionsView();
			this._initInternalTools();
			if (window.dataLayer.hasOmcRebates && window.dataLayer.enableOmcRebates) {
				import('views/store/pages/products/omc_rebates').then((OmcRebatesView) => {
					this.childViews.omcRebates = new OmcRebatesView();
				});
			}

			// initialize tooltips if any();
			$('[data-toggle="tooltip"]').tooltip();
			this.initProp65Popover();

			jsCookie.set(cookies.LAST_PRODUCT, window.location.href, {
				path: '/'
			});
			this._handlePreselectedTabs(window.location.hash);

			// Set default true so the finish price is not formatted
			if (typeof window.dataLayer.selectedFinish.price === 'string') {
				window.dataLayer.selectedFinish.isDefault = true;
			}
			this.listenTo(Backbone, 'body:click', this._handleBodyClick);
			// Select the finish
			Backbone.trigger('finish:clicked', window.dataLayer.selectedFinish);
		});
		clientUtils._initPopovers('.js-tech-spec');
		this.listenTo(Backbone, 'body:click', this._handleBodyClickPDP);
	},

	onScroll: function(e) {
		e.preventDefault();
		const $specs = $('#specificationsRow'),
			$description = $('#descriptionRow'),
			$reviews = $('#reviewsRow'),
			$questions = $('#questionsRow'),
			$pdpNav = $('#pdpHorizontalNav'),
			topHeaderOffset = 200,
			specsOffsetTop = $specs.length ? $specs.offset().top : 0,
			descOffsetTop = $description.length ? $description.offset().top : 0,
			reviewsOffsetTop = $reviews.length ? $reviews.offset().top : 0,
			questionsOffsetTop = $questions.length ? $questions.offset().top : 0;
		// Check the offset in order.
		if ($(window).scrollTop() >= descOffsetTop - topHeaderOffset) {
			$pdpNav.find('li.active').removeClass('active');
			$pdpNav
				.find('a[href="#descriptionRow"]')
				.parent('li')
				.addClass('active');
		}
		if ($(window).scrollTop() >= specsOffsetTop - topHeaderOffset) {
			$pdpNav.find('li.active').removeClass('active');
			$pdpNav
				.find('a[href="#specificationsRow"]')
				.parent('li')
				.addClass('active');
		}
		if ($(window).scrollTop() >= reviewsOffsetTop - topHeaderOffset) {
			$pdpNav.find('li.active').removeClass('active');
			$pdpNav
				.find('a[href="#reviewsRow"]')
				.parent('li')
				.addClass('active');
		}
		if ($(window).scrollTop() >= questionsOffsetTop - topHeaderOffset) {
			$pdpNav.find('li.active').removeClass('active');
			$pdpNav
				.find('a[href="#questionsRow"]')
				.parent('li')
				.addClass('active');
		}
	},

	// Explicit method for linkTracking since we need to alter the linkId based
	// off if the product header is fixed or not.
	_trackAnchorLink: function(e) {
		const $el = $(e.currentTarget),
			isFixed = $('#productHeaderBlock').hasClass('affix'),
			linkId = (isFixed ? 'stickyHeader-' : 'headerAnchorLink-') + $el.data('linkid');
		Backbone.trigger('omniture:clicktracking', linkId, null, 'none');
	},
	_techSpecPopoverPDP: function(e) {
		const currentTarget = e.currentTarget;
		const techSpecClass = '.js-tech-spec';
		clientUtils._handleMultiplePopoversClick(techSpecClass, currentTarget);
		// mainly prevent body click event from firing.
		e.stopPropagation();
	},
	_handleBodyClickPDP: function(e) {
		const targetElement = $(e.target);
		// any new popover triggering classes on the page to be added to this string to handle its body click hiding action
		const allPopoverClassesOnPage = '.js-tech-spec, .js-prop-65-popover';
		clientUtils._handleBodyClick(targetElement, allPopoverClassesOnPage);
	},
	_initRestrictionsView: function() {
		const restrictions = window.dataLayer.restrictions;
		this.childViews.restrictions = new RestrictionsView({
			el: '.js-product-restrictions-container',
			collection: restrictions,
			finishes: this.model.get('finishes'),
			selectedFinish: this.model.get('selectedFinish'),
			productCompositeId: this.model.get('productCompositeId')
		});
	},
	_addAccessoryToCart: function(event) {
		event.preventDefault();

		var $btn = $(event.currentTarget),
			cartItem = new CartItemModel({
				quantity: 1,
				uniqueId: $btn.next('input').val()
			});
		$btn.button('loading');
		cartItem.save(null, {
			success: (model, response) => {
				if (model.get('status') === 1) {
					window.BCOM.notifications.render(
						'You have added an item to your cart <a href="/checkout/cart" class="btn ml3">View Cart</a>',
						'success'
					);
					window.BCOM.util.trackCartAddition(model.attributes);
					Backbone.trigger('addToCart:productAdded', model);
					Backbone.trigger('cart:quantityChanged', model.get('cart').quantity);
					Backbone.trigger('omniture:productaddtocart', 'accessory', response, model, null);
				} else {
					window.BCOM.notifications.render('There was a problem adding this item to your cart. Please try again.', 'danger');
				}
				$btn.button('reset');
			}
		});
	},
	initProp65Popover: () => {
		// add elements to the whitelist so they are not removed by sanitizer
		// @ts-ignore
		const whiteList = $.fn.popover.Constructor.DEFAULTS.whiteList;
		whiteList.table = [];
		whiteList.tbody = [];
		whiteList.tr = [];
		whiteList.th = [];
		whiteList.td = [];
		const $popoverTarget = $('.js-prop-65-popover');
		$popoverTarget.popover({
			title: 'Proposition 65 Applicable (CA Only)',
			placement: 'top',
			trigger: 'click',
			html: true,
			sanitize: true
		});
	},
	_toggleProp65Popover: function() {
		$('.js-prop-65-popover').popover('toggle');
		// mainly prevent body click event from firing.
		return false;
	},

	_handleBodyClick: function(e) {
		const $targetElement = $(e.target);
		if (!$targetElement.parents().hasClass('popover') && !$targetElement.hasClass('popover')) {
			$('.js-prop-65-popover').popover('hide');
		}
	},

	_initAccessoriesTab: function() {
		this._initSlickSlider();
	},

	_initSlickSlider: function() {
		const $slider = $('.accessory-slick-slider');
		if ($slider && $slider.length) {
			$slider.not('.slick-initialized').slick({
				infinite: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				responsive: [
					{ breakpoint: 992, settings: { slidesToShow: 3 } },
					{ breakpoint: 1200, settings: { slidesToShow: 4 } }
				]
			});
		}
	},

	_handlePreselectedTabs: function(hash) {
		if (hash && hash.endsWith('tab')) {
			this.scrollToTabContent(hash.substr(1));
		}
	},
	refreshView: function(newModel) {
		if (window.BCOM.views.questions) {
			window.BCOM.views.questions.remove();
			window.BCOM.views.questions = null;
		}
		this.childViews = {};
		this.model = new ProductModel(newModel);
		this.initialize();
		$('#product-tabs li a[href="#q-and-a"]').on('shown.bs.tab', this._initQuestions.bind(this));
		this.delegateEvents();
		this.initChildViews();
	},
	initChildViews: function() {
		this._initReviews();
		this._initVideos();
		this._initQuestions();
		this._initParts();
		this._initInternalTools();
	},

	trackHoverClick: function(e) {
		e.preventDefault();
		Backbone.trigger('omniture:clicktracking', `${this._getDevice()}hoverTechSpecs_${e.currentTarget.title}`);
	},

	// init tabs
	openTab: function(e) {
		e.preventDefault();
		$(e.currentTarget).tab('show');
		this.selectedTabHash = e.currentTarget.hash;
		this._trackProductTab();
	},

	updateRecommendedOptionQuantities: function(quantityInfo) {
		var quantity;

		if (this.model.hasPricingByUOM()) {
			quantity = this.model.getQuantityForSquareFootage(quantityInfo.quantity);
		} else {
			quantity = quantityInfo.quantity;
		}

		if (quantityInfo.id === 'main-product-quantity') {
			this.model.recommendedOptions.each(function(option) {
				option.set('quantity', quantity);
			});
			this.childViews.recommendedOptions.forEach((optionView) => {
				optionView.matchOptionQuantityToProductQuantity();
			});
		}
	},

	handleOrientationChange: function(isLandscape) {
		if (isLandscape && this.selectedTabHash === '#product-specs-portrait') {
			this.$('#product-tabs li:first a').trigger('click');
		}
	},

	scrollToTabContent: function(data) {
		let $tab = $(`#${data}`);
		if ($tab && $tab.length) {
			const alreadyOnTab = $tab
				.closest('.panel')
				.find('.panel-collapse')
				.hasClass('in');
			if (data && !alreadyOnTab) {
				$tab.find('[data-toggle="collapse"]').trigger('click');
			}

			$.scrollTo($tab, 800, {
				axis: 'y'
			});
		}
	},
	_trackProductTab: function() {
		Backbone.trigger('omniture:clicktracking', `${this._getDevice()}tab_${this.selectedTabHash.replace('#', '')}`);
	},
	// tracking for link to reviews
	_trackReviewLink: function() {
		Backbone.trigger('omniture:clicktracking', `${this._getDevice()}tab_rating-link`);
	},

	_onShowReview: function() {
		this._scrollToTab('#reviews');
	},

	_initReviews: function(callback = null) {
		if (!this.childViews.reviews) {
			this.childViews.reviews = new ReviewsView({
				el: 'body',
				url: window.dataLayer.bvUrl,
				zone: window.dataLayer.bvDeploymentZone,
				productId: window.dataLayer.product.familyId,
				callback,
				onShowReview: this._onShowReview.bind(this, Backbone)
			});
			this._addViewMoreButton('reviews', '.bv-cleanslate');
		}
	},

	_initQuestions: function() {
		const isEdgeStar = window.dataLayer.siteId === 95;
		const isAlreadyLoaded = window.BCOM.views.questions;
		const productCompositeId = this.model.get('productCompositeId');

		if (!isEdgeStar && !isAlreadyLoaded) {
			window.BCOM.views.questions = new QuestionsView({ productCompositeId });
			this._addViewMoreButton('q-and-a', '.q-and-a-list');
		}
	},

	_getDevice: function() {
		const tabletOrDesktop = window.BCOM.device.isTablet ? 'tablet' : 'desktop';
		return window.BCOM.device.isMobile ? 'mobile' : tabletOrDesktop;
	},

	_initVideos: function() {
		if (!this.childViews.video) {
			this.childViews.video = new VideosView({
				parentView: this,
				el: '#videos'
			});
			// Need to set height of videos since video images
			// are loaded async which breaks view more button functionality
			var height = $('#videos').width() * 0.5625;
			$('#videos .video div:first-child').height(height);

			this._addViewMoreButton('videos', '.video');
		}
	},

	_notifyClosedModal: function() {
		Backbone.trigger('modal:close');
	},

	printWindow: function() {
		window.print();
	},

	_initParts: function() {
		try {
			if (!this.childViews.parts) {
				import('views/store/pages/products/parts_tab').then((PartsView) => {
					this.childViews.parts = new PartsView();
					this._addViewMoreButton('parts', '.parts-grid li');
				});
			}
		} catch (e) {
			window.clientErrorHandler(e);
		}
	},
	_toggleFullTab: function(e) {
		var $div = $(e.currentTarget),
			$btn = $div.find('button'),
			tab = $btn.data('tab'),
			isViewMore = $btn.text().toLowerCase() === 'view more';

		$btn.text(isViewMore ? 'View Less' : 'View More');

		if (!isViewMore) {
			setTimeout(function() {
				$('body').animate(
					{
						scrollTop: $(`#${tab}`).offset().top + 800
					},
					1000
				);
			}, 200);
		}
		$div.siblings('.js-content').toggleClass('full');
		Backbone.trigger('omniture:clicktracking', `${tab} tab:view more`);
	},
	_toggleFullSubHeading: function(e) {
		e.preventDefault();
		this.$('.js-full-title-toggle').toggleClass('hidden');
		this.$('.js-full-title').toggleClass('show-partial');
	},
	_finishMenuClosed: function() {
		Backbone.trigger('omniture:clicktracking', 'finish menu:closed');
	},
	_loadTabs: function() {
		if (!this.tabsLoaded) {
			this._addViewMoreButton('specifications', '.table');
			this.tabsLoaded = true;
		}
	},
	_addViewMoreButton: function(tab, elementLoaded) {
		if (window.BCOM.device.isMobile) {
			var $content = $(`#${tab} .js-content`),
				partialHeight = parseInt($content.css('max-height'), 10);

			window.BCOM.util.elementLoaded(
				{
					selector: `#${tab}${elementLoaded ? ` ${elementLoaded}` : ''}`
				},
				function() {
					if ($content.length && $content[0].scrollHeight > partialHeight && !$content.siblings('.js-view-more').length) {
						dustjs.render(
							_viewMoreButtonDust,
							{
								tab: tab
							},
							function(err, markup) {
								$content.after(markup);
							}
						);
					}
				}
			);
		}
	},
	_initInternalTools: function() {
		if (window.dataLayer.isLocalUser) {
			import('views/store/pages/products/internal_tools').then((InternalToolsView) => {
				this.childViews.internalTools = new InternalToolsView();
			});
		}
	},
	saveLastProductUrl: function(lastProductUrl) {
		jsCookie.set(cookies.LAST_PRODUCT, lastProductUrl, {
			expires: 45,
			path: '/'
		});
	},
	_onAvailabilityChanged: function(params) {
		if (params.newState !== 'AVAILABLE') {
			return;
		}

		var uniqueId = parseInt(params.uniqueId, 10);
		var selectedFinish = this.model.finishes.getSelectedFinish();
		if (uniqueId !== selectedFinish.get('uniqueId')) {
			return;
		}

		var oldHasPricedOptions = this.model.hasPricedOptionsExcludingInstall();
		var newHasPricedOptions = !params.services || params.services.length > 0;
		if (oldHasPricedOptions !== newHasPricedOptions) {
			var buttons = this.$('.js-add-to-cart');
			if (newHasPricedOptions && this.originalAddText) {
				buttons.html(this.originalAddText);
			} else {
				this.originalAddText = buttons.html();
				buttons.html(this.originalAddText.replace(buttons.text(), 'Add To Cart'));
			}
		}

		this.model.set('hasPricedOptionsExcludingInstall', newHasPricedOptions);
	},
	_creditCardLanding: function(event) {
		event.preventDefault();
		const trackingData = {
			evars: {
				eVar2: `creditcard|pg_${window.dataLayer.page}|t_${window.dataLayer.product.type}|a_${window.dataLayer.product.application}|m_${window.dataLayer.manufacturer}`
			},
			redirect: $(event.currentTarget)
				.closest('a')
				.attr('href')
		};

		gtmHelper.fireEvent({
			event: 'internal-campaign-click',
			linkName: trackingData.evars.eVar2
		});

		Backbone.trigger('track:link', trackingData);
	}
});
